<template>
    <div class="wrapper d-flex">
        <div class="circle-green mx-auto mt-auto">
            <div class="circle-white">
            </div>
              <svg class="check-svg" :class="view ? 'view' : 'normal'" width="70" height="70" viewBox="0 0 70 70">
            <polyline
                class="check-poly"
                points="23 34 34 43 47 27"
                stroke-linecap="round" />
        </svg>
        </div>
      
    </div>

</template>

<script>
export default {
    name: 'SubmitSuccess',

    props: {
        view: Boolean
    }

}
</script>

<style lang="scss" scoped>
$green: #26af04;
$check-length: 36px;

body {
    padding: 40px;
}

.wrapper {
    position: relative;
}

.circle-green {
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: $green;
    animation: expand 1s cubic-bezier(0.77, 0, 0.175, 1) forwards;
}

.circle-white {
    position: relative;
    top: 4px;
    left: 4px;
    width: 92px;
    height: 92px;
    transform: scale(0);
    border-radius: 50%;
    background: white;
    animation: expand 1s 0.5s cubic-bezier(0.77, 0, 0.175, 1) forwards;
}

@keyframes expand {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}

.check-svg {
    position: absolute;
    width: 140px;
    height: 140px;
    top: -18px;
    left: -18px;
    transform-origin: center;
    animation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0.7s 1 both scaleCheck;
}

.check-poly {
    fill: transparent;
    stroke-width: 2;
    stroke-dasharray: $check-length $check-length;
    stroke: $green;
    animation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0.7s 1 both drawCheck;
}

@keyframes scaleCheck {
    0% {
        opacity: 0;
    }

    1% {
        opacity: 1;
    }

    100% {
        transform: scale(1);
    }
}

@keyframes drawCheck {
    0% {
        stroke-dashoffset: $check-length;
    }

    100% {
        stroke-dashoffset: 0;
    }
}
</style>
